import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {styles} from "../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import LoadingBasic from '../skeletons/loading_history_zajavl';
import {withTranslation} from "react-i18next";

class ZajavlHistoryDialog extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            classes,
            isOpenHistoryDialog,
            handleCloseHistoryDialog,
            historyZajavl,
            loadingHistoryZajavl,
            t,
            i18n
        } = this.props;

        return(
            <Dialog
                open={isOpenHistoryDialog}
                onClose={handleCloseHistoryDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
            >
                <DialogTitle id="alert-dialog-title">{t('application_status_change_history')}</DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table className={classes.tableBorder} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant="body1">#</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('time')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('application_status')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('changed_by')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('comment')}</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadingHistoryZajavl
                                    ? <LoadingBasic/>
                                    : historyZajavl.map((historyZajavlRow, rowIndex) => {
                                        return (
                                            <TableRow key={historyZajavlRow.id}>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {historyZajavl.length - rowIndex}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {historyZajavlRow.create_date_view}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {i18n.language === "en" && historyZajavlRow.status_view_en
                                                            ? historyZajavlRow.status_view_en
                                                            : historyZajavlRow.status_view}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {i18n.language === "en" && historyZajavlRow.name_view_en
                                                            ? historyZajavlRow.name_view_en
                                                            : historyZajavlRow.name_view}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {historyZajavlRow.comment}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseHistoryDialog} color="primary" autoFocus>
                        {t('close')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

function mapStateToProps(state) {
    const {historyZajavl, loadingHistoryZajavl} = state;
    return {
        historyZajavl,
        loadingHistoryZajavl,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(ZajavlHistoryDialog));